import React, { useState } from 'react';
import getInjuryStatusColor from '../../../utils/getInjuryStatusColor';

const QbTetherAlert = ({ alert, compact = false }) => {
	const [
		isTooltipVisible,
		setTooltipVisible
	] = useState(false);

	if (!alert) return null;

	const statusColor = getInjuryStatusColor(alert.qbStatus);

	const handleTooltipToggle = () => {
		setTooltipVisible((prev) => !prev);
	};

	return (
		<div className="relative inline-flex shrink-0 items-center leading-none">
			<button
				type="button"
				className={`inline-flex items-center justify-center rounded-full border p-0 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 bg-amber-50/80 dark:bg-amber-950/30 border-amber-200/80 dark:border-amber-800/60 hover:bg-amber-100/90 dark:hover:bg-amber-950/50 ${compact
					? 'h-5 w-5 min-h-0 min-w-0'
					: 'h-7 w-7 min-h-0 min-w-0'}`}
				style={{ borderColor: `${statusColor}55` }}
				aria-label={`${alert.tooltipTitle}: ${alert.message}`}
				onMouseEnter={() => setTooltipVisible(true)}
				onMouseLeave={() => setTooltipVisible(false)}
				onClick={handleTooltipToggle}
			>
				<i
					className={`fa-solid fa-link ${compact ? 'text-[10px]' : 'text-xs'}`}
					style={{ color: statusColor }}
					aria-hidden="true"
				/>
			</button>
			{isTooltipVisible && (
				<div
					className={`absolute bottom-full left-1/2 z-20 mb-2 w-max max-w-xs -translate-x-1/2 rounded-md bg-black px-3 py-2 text-left text-white shadow-lg ${compact ? 'text-xs' : 'text-sm'}`}
					role="tooltip"
				>
					<div className="font-semibold">{alert.tooltipTitle}</div>
					<div className="mt-1 text-gray-200 leading-snug">{alert.tooltipBody}</div>
					<div className="mt-1.5 text-gray-300 text-xs">{alert.message}</div>
				</div>
			)}
		</div>
	);
};

export default QbTetherAlert;
